import { Stack, Text, useTheme } from '@ltvco/refresh-lib/theme';
import {
  HelpOutline,
  CampaignOutlined,
  Close,
  InsertDriveFile as InsertDriveFileIcon,
} from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useContext, useState } from 'react';

import {
  BrandLogoChat,
  NewChatButton,
  HelpModal,
  ChatPageBoxContainer,
  SidebarIcon,
} from 'components/ChatBV/components';
import { FEEDBACK_FORM_URL } from 'components/ChatBV/constants';
import { ChatContext } from 'components/ChatBV/context/ChatContext';

interface ChatPageSidebarMobileProps {
  isOpen: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsOpen: (isOpen: boolean) => void;
  onRecentReportsClick?: () => void;
  onCloseRecentReports?: () => void;
}

export const ChatPageSidebarMobile = ({
  isOpen,
  setIsOpen,
  onRecentReportsClick,
  onCloseRecentReports,
}: ChatPageSidebarMobileProps) => {
  const theme = useTheme();
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const { handleNewChat } = useContext(ChatContext);

  const handleNewChatClick = () => {
    handleNewChat();
    onCloseRecentReports?.();
    setIsOpen(false);
  };

  const handleRecentReportsClick = () => {
    onRecentReportsClick?.();
    setIsOpen(false); // Close mobile sidebar when opening recent reports
  };

  return (
    <ChatPageBoxContainer
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100vh"
      boxShadow="4px 0 8px rgba(0, 0, 0, 0.15)"
      zIndex={1000}
      isAnimatingOut={!isOpen}
    >
      <Stack spacing={3} padding={3} height="100%">
        <Stack
          alignItems="center"
          spacing={2}
          marginBottom={4}
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
        >
          <BrandLogoChat width="116px" height="16px" />
          <Close
            onClick={() => {
              setIsOpen(false);
            }}
            sx={{
              marginTop: '0 !important',
            }}
          />
        </Stack>

        <Stack spacing={2} flex={1}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              marginBottom: '32px !important',
            }}
            onClick={handleNewChatClick}
          >
            <NewChatButton variant="contained">
              <AddIcon
                sx={{
                  width: '20px',
                  height: '20px',
                  color: theme.palette.text.contrastText,
                }}
              />
            </NewChatButton>
            <Text
              variant="body1"
              fontWeight="bold"
              color={theme.palette.primary.main}
            >
              New Chat
            </Text>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              marginBottom: '32px !important',
            }}
            onClick={handleRecentReportsClick}
          >
            <InsertDriveFileIcon
              sx={{
                width: '20px',
                height: '20px',
                color: theme.palette.text.secondary,
              }}
            />
            <Text
              variant="body1"
              fontWeight="bold"
              color={theme.palette.primary.main}
            >
              Report Library
            </Text>
          </Stack>
        </Stack>

        <Stack spacing={2}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="start"
            justifyContent="start"
            sx={{
              width: '100%',
            }}
            onClick={() => setOpenHelpModal(true)}
          >
            <SidebarIcon>
              <HelpOutline />
            </SidebarIcon>
            <Text variant="body1">Help</Text>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            alignItems="start"
            justifyContent="start"
            sx={{
              width: '100%',
            }}
            onClick={() => window.open(FEEDBACK_FORM_URL, '_blank')}
          >
            <SidebarIcon>
              <CampaignOutlined />
            </SidebarIcon>
            <Text variant="body1">Feedback</Text>
          </Stack>
        </Stack>
        <HelpModal
          open={openHelpModal}
          onClose={() => setOpenHelpModal(false)}
        />
      </Stack>
    </ChatPageBoxContainer>
  );
};
